import React, { useState } from 'react';

import { Alert, Box, Link, Typography } from 'components/AORedesign';
import { handleFileDownload } from 'components/CommonUtilityServices/DownloadFileService';
import { handlePdfDownload } from 'components/CommonUtilityServices/DownloadPdfService';
import { Feature } from 'components/Feature';
import { SALES_AND_SERVICE_CENTER_INFO_REQUEST } from 'constants/emails';
import { CUSTOMER_SERVICES_OVERVIEW_LINK, CUSTOMER_SERVICES_PHONE_QUICK_REFERENCE_LINK, MAILING_AND_CONTACT_INFORMATION_LINK } from 'constants/static';
import LinksContainer from './LinksContainer';

const PDF_ICON = 'pdf';
const OPEN_IN_NEW_TAB_ICON = 'openInNew';

const MsaResources = () => {
  const [isDownloadingPdfErrorVisible, setIsDownloadingPdfErrorVisible] = useState(false);
  const [downloadingPdfError, setDownloadingPdfError] = useState('');

  const handleClickDownloadFile = (event) => {
    setIsDownloadingPdfErrorVisible(false);
    const pdfUrl = event.currentTarget.getAttribute('data-pdf');
    if (pdfUrl) {
      handlePdfDownload('GET', null, pdfUrl, () => {}, setDownloadingPdfError, setIsDownloadingPdfErrorVisible, 'newWindow');
    } else {
      const _fileUrl = event.currentTarget.getAttribute('data-file');
      handleFileDownload(_fileUrl, () => {}, setDownloadingPdfError, setIsDownloadingPdfErrorVisible);
    }
  };

  const resetErrorVisibility = () => {
    setIsDownloadingPdfErrorVisible(false);
  };
  return (
    <Box mb={2}>
      <Box mt={1} mb={4}>
        <Typography variant="h6">Main Street America</Typography>
      </Box>
      {isDownloadingPdfErrorVisible && (
        <Box mb={2}>
          <Alert color="error" alertTitleMessage={downloadingPdfError} />
        </Box>
      )}
      <Box>
        <LinksContainer heading="about us">
          <Link onClick={resetErrorVisibility} href={'https://msainsurance.com/'} endIcon={OPEN_IN_NEW_TAB_ICON}>
            Company Website
          </Link>
        </LinksContainer>
        <LinksContainer heading="sales & service center">
          <Link href="https://cdn.bfldr.com/XVKWUUUT/as/69r52thrk3tbnwn8h8nksvxj/Service_Center_-_Write_vs_Service_Flyer_40-K460" endIcon={PDF_ICON}>
            Grow Your Business
          </Link>
          <Link href="https://cdn.bfldr.com/XVKWUUUT/as/pq4wxzg8vwwnwgjw8nhwjc7r/MSA_Service_Center_FAQ_40-V384" endIcon={PDF_ICON}>
            MSA Service Center FAQ
          </Link>
          <Link onClick={resetErrorVisibility} href={SALES_AND_SERVICE_CENTER_INFO_REQUEST} endIcon="mail">
            Sales & Service Center Info Request
          </Link>
        </LinksContainer>
        <LinksContainer heading="Massachusetts power of attorney (poa)">
          <Link data-pdf={'/resources/MA_POA_Form_NGM_3.31.22.pdf'} onClick={handleClickDownloadFile} endIcon={PDF_ICON}>
            Authorization To Sign Motor Veh. Reg. Certificate (NGM)
          </Link>
          <Link data-pdf={'/resources/MA_POA_Form-MSAPIC_3.31.22.pdf'} onClick={handleClickDownloadFile} endIcon={PDF_ICON}>
            Authorization To Sign Motor Veh. Reg. Certificate (MSP)
          </Link>
        </LinksContainer>
        <LinksContainer heading="security & policies">
          {/* Hiding links under https://amfament.atlassian.net/browse/E1PMAO-13450 while training team works on getting new links. No timeframe */}
          <Feature allowed={[]}>
            <Link onClick={resetErrorVisibility} href={''} endIcon={OPEN_IN_NEW_TAB_ICON}>
              Website Security Guide
            </Link>
          </Feature>
          <Link href={'https://brandfolder.com/s/nk4p4jncmkghtwjfbf9c4svj'} endIcon="openInNew">
            Agent Security Form
          </Link>
          <Link
            onClick={resetErrorVisibility}
            href={`/assets/documents/agency-automation/security_risk_assessment.pdf`}
            endIcon={OPEN_IN_NEW_TAB_ICON}>
            IA Risk Assessment
          </Link>
          <Link href={'https://survey.az1.qualtrics.com/jfe/form/SV_ba2OFLFwlsh9kUe '} endIcon="openInNew">
            Licensing Questionnaire
          </Link>
          <Link data-pdf={'/resources/Electronic_Signature_Policy.pdf'} onClick={handleClickDownloadFile} endIcon={PDF_ICON}>
            Electronic Signature Policy
          </Link>
        </LinksContainer>
        <LinksContainer heading="automation forms">
          <Link data-pdf={'/resources/Agency_EFT_Commission_Deposit_Form.pdf'} onClick={handleClickDownloadFile} endIcon={PDF_ICON}>
            Agency EFT Form
          </Link>
        </LinksContainer>
        <LinksContainer heading="contacts">
          <Link href={CUSTOMER_SERVICES_OVERVIEW_LINK} endIcon={OPEN_IN_NEW_TAB_ICON}>
            Customer Services Overview
          </Link>
          <Link href={CUSTOMER_SERVICES_PHONE_QUICK_REFERENCE_LINK} endIcon={OPEN_IN_NEW_TAB_ICON}>
            Customer Services Phone Line Quick Reference
          </Link>
          <Link href={MAILING_AND_CONTACT_INFORMATION_LINK} endIcon={OPEN_IN_NEW_TAB_ICON}>
            Mailing & Contact Information
          </Link>
        </LinksContainer>
      </Box>
    </Box>
  );
};

export default MsaResources;
